import dayjs from 'dayjs'
import { useSession } from 'next-auth/react'
import Script from 'next/script'
import { useFirstAndLastOrderDate } from 'providers/orders/useFirstAndLastOrderDate'
import { useEffect } from 'react'

const DelightedSnippet: React.FC = () => {
  const { data: sessionData } = useSession()
  const { user } = sessionData || {}

  const {
    data: firstAndLastOrderDate,
    isLoading: isLoadingFirstAndLastOrderDate
  } = useFirstAndLastOrderDate()

  const { firstDate: firstOrderDate, lastDate: lastOrderDate } =
    firstAndLastOrderDate || {}

  useEffect(() => {
    const hasOrderInTheLast90Days =
      lastOrderDate &&
      dayjs(lastOrderDate).isAfter(dayjs().subtract(90, 'days'))

    if (!hasOrderInTheLast90Days) {
      return
    }

    if (user?.email && !isLoadingFirstAndLastOrderDate) {
      const initial30DaysDelay = 30 * 24 * 60 * 60

      const currentTime = dayjs()
      const userCreatedAt = user?.created_at
        ? dayjs(user.created_at)
        : currentTime

      const userCreatedLessMinDate =
        currentTime.diff(userCreatedAt, 'seconds') < initial30DaysDelay

      const startSurveyRefDate = userCreatedLessMinDate
        ? userCreatedAt.toString()
        : firstOrderDate

      window['delightedSurvey']({
        email: user?.email,
        corporateName: user?.corporate?.name,
        startSurveyRefDate,
        planType: user?.corporate?.data?.planType,
        nameOnCard: user?.corporate?.data?.name,
        initialDelay: initial30DaysDelay
      })
    }
  }, [user, isLoadingFirstAndLastOrderDate, firstOrderDate, lastOrderDate])

  return (
    <>
      {/* spacer to survey */}
      <div className="h-[110px] w-full"></div>
      <Script id="delighted-snippet" strategy="afterInteractive">
        {`
            function delightedSurvey(credentials) {
              !(function (e, t, r, n) {
                if (!e[n]) {
                  for (
                    var a = (e[n] = []),
                      i = [
                        'survey',
                        'reset',
                        'config',
                        'init',
                        'set',
                        'get',
                        'event',
                        'identify',
                        'track',
                        'page',
                        'screen',
                        'group',
                        'alias',
                      ],
                      s = 0;
                    s < i.length;
                    s++
                  ) {
                    var c = i[s];
                    a[c] =
                      a[c] ||
                      (function (e) {
                        return function () {
                          var t = Array.prototype.slice.call(arguments);
                          a.push([e, t]);
                        };
                      })(c);
                  }
                  a.SNIPPET_VERSION = '1.0.1';
                  var o = t.createElement('script');
                  (o.type = 'text/javascript'),
                    (o.async = !0),
                    (o.src =
                      'https://d2yyd1h5u9mauk.cloudfront.net/integrations/web/v1/library/' +
                      r +
                      '/' +
                      n +
                      '.js');
                  var p = t.getElementsByTagName('script')[0];
                  p.parentNode.insertBefore(o, p);
                }
              })(window, document, 'bqhn6AKWJfhcpE46', 'delightedNps4');

              delightedNps4.survey({
                email: credentials.email,
                name: credentials.corporateName,
                createdAt: credentials.startSurveyRefDate,
                initialDelay: credentials.initialDelay,
                properties: {
                  plan: credentials.planType,
                  company: credentials.nameOnCard,
                },
              });
            }
          `}
      </Script>
    </>
  )
}

export default DelightedSnippet
